import {createSelector} from 'reselect';
import {IStore} from './reducers';

import {
  STATUS_NO_ACCESS,
  STATUS_NO_ACCESS_CAM,
  STATUS_NO_ACCESS_MIC,
  STATUS_CONNECTED,
  STATUS_DISCONNECTED,
  STATUS_CONNECTION_FAILED,
  STATUS_OK,
} from '../modules/video/constants';

const isDisconnected = (state) => (
  state.video.status === STATUS_DISCONNECTED
    && !state.editor.editorConnected
    && !state.webSocket.connected
);

export const selfStatusSelector = createSelector(
  ({video}: IStore): string => video.status,
  ({editor}: IStore): boolean => editor.editorConnected,
  ({webSocket}: IStore): boolean => webSocket.connected,
  (videoStatus: string, editorConnected: boolean, webSocketConnected: boolean) => {
    const videoProblemStatuses: string[] = [
      STATUS_NO_ACCESS,
      STATUS_NO_ACCESS_CAM,
      STATUS_NO_ACCESS_MIC,
      STATUS_CONNECTION_FAILED,
    ];

    if (videoProblemStatuses.indexOf(videoStatus) >= 0) {
      return videoStatus;
    } else if (videoStatus === STATUS_DISCONNECTED && webSocketConnected) {
      return STATUS_CONNECTED;
    } else if (videoStatus === STATUS_CONNECTED && editorConnected) {
      return STATUS_OK;
    } else {
      return STATUS_DISCONNECTED;
    }
  },
);

export const peerStatusSelector = (state: IStore): string => {
  // assume peer is also disconnected when user is disconnected
  if (isDisconnected(state)) {
    return STATUS_DISCONNECTED;
  }

  return state.video.peerStatus;
};

export const showRunCodeHintSelector = createSelector(
  ({session}: IStore): boolean => session.showRunCodeHint,
  ({session}: IStore): boolean => session.isInterviewer,
  selfStatusSelector,
  (showRunCodeHint: boolean, isInterviewer: boolean, selfStatus: string) => (
    showRunCodeHint && !isInterviewer && selfStatus === STATUS_OK
  ),
);

export const showRunCodeHintAcknowledgedSelector = (state: IStore): boolean => (
  !state.session.showRunCodeHint
);

const normalizeFirebaseLink = url => url.replace('#', '_sharp');

export const linkSelector = createSelector(
  ({session}: IStore): string => session.code.language,
  ({session}: IStore): string => session.rootPath,
  ({session}: IStore): string => session.intervieweeUserId,
  (language: string, rootPath: string, intervieweeUserId: string) => (
    language
      ? ['/firepads', rootPath, intervieweeUserId, normalizeFirebaseLink(language)].join('/')
      : ''
  ),
);

export const placementSessionLinkSelector = state => (
  state.session.code.language
    ? ['/firepads', 'placement', state.session.rootPath, normalizeFirebaseLink(state.session.code.language)].join('/')
    : ''
);
